module.exports = __webpack_public_path__ + "static/media/arrow-blue.1732bb64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-blue.svg
// module id = 1542
// module chunks = 0